import { z } from 'zod'

/**
 * The query param naming which view of the threat model tab is open.
 *
 * In `utils/` rather than beside the tab because two routes address it: the tab owns the navigation, and
 * the repositories page links straight to a sub-view from its risk drawer. `architecture.test.ts` forbids
 * one route importing another, and a second copy of the string would drift the first time it changed.
 */
export const THREAT_MODEL_VIEW_PARAM = 'threatModelView'

/**
 * The views that param can name.
 *
 * Here for the same reason as the param itself, and it is why the drawer's deep link used to spell
 * `scorecards` by hand: the enum lived in the tab, which the repositories page cannot import. A renamed
 * view would have degraded that link to the default view in silence, because `parseThreatModelView`
 * swallows a value it does not recognise. Now a rename is a compile error at every call site.
 */
export const THREAT_MODEL_VIEWS = ['overview', 'surface', 'scorecards', 'adjudication', 'history', 'beacons'] as const

export const ThreatModelViewSchema = z.enum(THREAT_MODEL_VIEWS)
export type ThreatModelView = (typeof THREAT_MODEL_VIEWS)[number]

/** Falls back to the default view rather than throwing: a stale link should land somewhere useful. */
export const parseThreatModelView = (raw: string | null): ThreatModelView =>
  ThreatModelViewSchema.safeParse(raw).data ?? 'overview'

/** The `param=view` pair for a URL, so no caller assembles it from a bare string. */
export const threatModelViewSearch = (view: ThreatModelView): string => `${THREAT_MODEL_VIEW_PARAM}=${view}`
